import React, { useState } from 'react'
import { View } from '../../Components'
import { back, chevron_right, gear } from '../../Images/Icons'
import { home_solution } from '../../Images'
import { useNavigate } from 'react-router-dom'
import css from './ProfileDetailPage.module.scss'

let scrollTop = 0;
const ProfileDetailPage = () => {
    const navigate = useNavigate();
    const [state, setNewState] = useState({ isBGtopVisible: false, });

    const station_get = localStorage.getItem("station_get");
    const station = JSON.parse(localStorage.getItem('station'));
    const data_user = station.filter(stat => stat.station_code === atob(station_get));
    
    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigate(-1);
    }

    const onScroll = (e) => {
        if (parseInt(e.target.scrollTop) < 254 && isBGtopVisible) {
            setState({ isBGtopVisible: false });
        }
        if (parseInt(e.target.scrollTop) > 254 && isBGtopVisible == false) {
            setState({ isBGtopVisible: true });
        }
    }

    const { isBGtopVisible } = state;

    return (
        <div style={{ position: 'relative', }}>
            <div onScrollCapture={onScroll} className="page-content" style={{ maxHeight: '100vh', marginBottom: -64, display: 'flex', flexDirection: 'column', flex: 1, background: 'white', }}>
                <div style={{ position: 'relative' }}>
                    <div style={{ height: 274 }}>
                        <img src={home_solution} alt="" style={{ width: '100%', height: 274, objectFit: 'cover' }} />
                    </div>
                    <div style={{
                        height: 274, top: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(2555,0,0,0))', display: 'flex',
                        width: '100%', position: 'absolute', border: 'solid 0px'
                    }} >
                    </div>
                    <div style={{ margin: 20 }}>
                        <div style={{ height: 'auto'}}>
                            <div className={css.profile_info} style={{ cursor: 'pointer', background: '#F1F1F1' }}>
                                <div className={css.profile_initial}>P</div>
                                <View alignItems="start" flexDirection="column" style={{ margin: '0 8px' }}>
                                    <div style={{ fontSize: 14, fontWeight: 700, color: '#464646' }}>{data_user[0].station_name}</div>
                                    <div className={css.detail_profile}>
                                        <span>{data_user[0].power_kwp} kWp</span>
                                    </div>
                                </View>
                            </div>
                            <div style={{ marginTop: 20 }}>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Country Region</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>Indonesia</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Service Provider</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>PT  MODENA Energy Indonesia</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Plant Type</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>{data_user[0].plan_type}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>EV-Charger-Only Plant</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>No</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Plant Name</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>{data_user[0].station_name}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Total String Capacity (kWp)</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>{data_user[0].power_kwp}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Grid Connection Date</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>{data_user[0].grid_connection_date}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ height: 50 }}>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Start Date of Safe Running</div>
                                        <div style={{ fontSize: 13, fontWeight: 500, color: '#8f8f8f' }}>{data_user[0].start_date_safe_running}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                                <div>
                                    <View justifyContent="space-between" style={{ minHeight: 50, padding: '10px 0' }}>
                                        <div style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#2C313A' }}>Plant Address</div>
                                        <div style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#8f8f8f', textAlign: 'right' }}>{data_user[0].station_address}</div>
                                    </View>
                                    <div style={{ height: 1, background: '#CFD3DB' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', background: `${isBGtopVisible ? '#272727' : ''}`, position: 'absolute', top: 0, display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'start', }}>
                <div style={{height: 56,  display: 'flex', margin: '0 20px', alignItems: 'center' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Detail PLTS</div>
                </div>
            </div>
        </div>
    )
}

export default ProfileDetailPage